import React from 'react';
import { ThemeProvider } from './context/ThemeContext'; 
import AppSub from './AppSub.jsx';

function App() {
  return (
    <ThemeProvider>
      <AppSub />
    </ThemeProvider>
  );
}

export default App;